export type GetSeriesTypeListApiResponse = /** status 200  */ SeriesTypeResponseBody[];
export type GetSeriesTypeListApiArg = unknown;
export type BatchDeleteSeriesApiResponse = /** status 204  */ undefined;
export type BatchDeleteSeriesApiArg = {
  body: BatchDeleteSeriesListRequestBody;
};
export type CreateSeriesApiResponse = /** status 201  */ SeriesResponseBody;
export type CreateSeriesApiArg = {
  createSeriesRequestBody: CreateSeriesRequestBody;
};
export type GetSeriesListApiResponse = /** status 200  */ SeriesResponseBody[];
export type GetSeriesListApiArg = {
  search?: string;
  type?: SeriesType[];
};
export type GenerateSeriesNumberApiResponse = /** status 201  */ GenerateSeriesNumberResponseBody;
export type GenerateSeriesNumberApiArg = {
  seriesId: string;
};
export type GetSeriesApiResponse = /** status 200  */ SeriesResponseBody;
export type GetSeriesApiArg = {
  seriesId: string;
};
export type PatchSeriesApiResponse = /** status 200  */ SeriesResponseBody;
export type PatchSeriesApiArg = {
  seriesId: string;
  patchSeriesRequestBody: PatchSeriesRequestBody;
};
export type SeriesType =
  | 'accounting/cash_register_closure'
  | 'accounting/cash_register_document'
  | 'car-rental/rental-order'
  | 'accounting/invoice'
  | 'general/complaint'
  | 'general/contract'
  | 'general/customer'
  | 'general/export_document'
  | 'general/vehicle'
  | 'interest/interest'
  | 'new_and_used_cars/business_case'
  | 'pneu-hotel/tire-movement'
  | 'pneu-hotel/tire-order'
  | 'pneu-hotel/tire-set'
  | 'sales/vehicle-warehouse'
  | 'warehouse/dispense'
  | 'warehouse/inventory'
  | 'warehouse/order'
  | 'warehouse/offer'
  | 'warehouse/receipt'
  | 'warehouse/request'
  | 'warehouse/direct-sale'
  | 'warehouse/corrective-receipt'
  | 'workshop/service_case'
  | 'workshop/service_job'
  | 'workshop/service_order'
  | 'workshop/service_order_issue'
  | 'workshop/service_order_list'
  | 'workshop/service_order_offer'
  | 'workshop/service_order_parts_return'
  | 'workshop/service_order_claim'
  | 'workshop/workshop-interest'
  | 'warehouse/issue-note'
  | 'warehouse/issue-note-correction'
  | 'warehouse/fast-track'
  | 'warehouse/transfer-order'
  | 'pneu-hotel/tire-transport-document';
export type SeriesTypeResponseBody = {
  code: SeriesType;
  name: string;
  color: string;
};
export type BatchDeleteSeriesRequestBody = {
  id: string;
};
export type BatchDeleteSeriesListRequestBody = {
  items: BatchDeleteSeriesRequestBody[];
};
export type SeriesPatternStateEnum = 'not_used' | 'in_use' | 'expired';
export type SeriesPatternResponseBody = {
  prefix: string;
  startingNumber: number;
  length: number;
  from: string | null;
  to: string | null;
  state: SeriesPatternStateEnum;
};
export type SeriesIssueInfo = {
  number: string;
  issuedAt: string;
};
export type SeriesResponseBody = {
  id: string;
  name: string;
  type: SeriesType;
  patterns: SeriesPatternResponseBody[];
  firstIssueInfo: SeriesIssueInfo | null;
  lastIssueInfo: SeriesIssueInfo | null;
  unique: boolean;
  system: boolean;
  withPrefix: boolean;
};
export type SeriesPatternRequestBody = {
  prefix: string;
  startingNumber: number;
  length: number;
  from: string | null;
};
export type CreateSeriesRequestBody = {
  name: string;
  type: SeriesType;
  patterns: SeriesPatternRequestBody[];
  unique: boolean;
  withPrefix?: boolean;
};
export type SeriesIssueInfoDto = {
  number: string;
  issuedAt: string;
};
export type GenerateSeriesNumberResponseBody = {
  issueInfo: SeriesIssueInfoDto;
};
export type PatchSeriesRequestBody = {
  name?: string | null;
  type?: SeriesType | null;
  patterns?: SeriesPatternRequestBody[] | null;
  unique?: boolean | null;
  withPrefix?: boolean;
};
